import { Page } from '@touche-lts/panel-ui/dist'
import { OrdersDTO } from 'models'
import { FetchOptions } from 'services'
import { PaginationSearchBase } from '..'
import { OrdersTableSearchProps, OrdersTableSortProps } from './orders-table-base.types'
import {
    initialOrdersTablePaginationProps, 
    initialOrdersTableSearchProps, 
    ordersNeedTimeoutProps
} from './orders-table-base.utils'

export class OrdersTableBase extends PaginationSearchBase<
    OrdersTableSortProps,
    OrdersTableSearchProps,
    OrdersDTO
> {
  constructor () {
    super({
        initialPaginationProps: initialOrdersTablePaginationProps,
        initialSearchProps: initialOrdersTableSearchProps,
        needTimeoutProps: ordersNeedTimeoutProps
      })
  }

  public handleSearchResult = (data: Page<OrdersDTO>): void => {
    if (!data) return
    this.handleSearchResultPaginationProps(data)
    this.setSearchResults(data.content)
  }

  public getPageQueryParams = (
    resetPageNumber: boolean
  ): FetchOptions['pageQueryParams'] => {
    return {
      page: resetPageNumber ? 0 : this.pagination.page,
      size: this.pagination.size,
      sortDirection: this.pagination.sortDirection,
      sortProp: this.pagination.sortProp
    }
  }

  public get ordersFilter (): Partial<OrdersTableSearchProps> { //  Partial<OrdersTableSearchProps>
    return {
      customerId: this.searchProps.customerId,
      maxAmount: this.searchProps.maxAmount,
      maxDate: this.searchProps.orderDate
      ? this.searchProps.orderDate.end.toISOString()
      : null,
      minAmount: this.searchProps.minAmount,
      minDate: this.searchProps.orderDate
      ? this.searchProps.orderDate.start.toISOString()
      : null,
      number: this.searchProps.number,
      status: !!this.searchProps.status ? this.searchProps.status : null,
      store: this.searchProps.store
    }
  }
}
